import dayjs from 'dayjs';

export const API = {
  sendMail: {
    path: '/tickets/sendTicketsInfo',
    method: 'POST',
  },
  operations: {
    path: '/operation-lists?populate[id_department][fields][0]=name_department&populate[id_department]=%2A&populate[id_marina]=%2A&populate[id_service]=%2A&populate[id_user_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_mexal_person_in_charge]=%2A&populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user][fields][0][1]=name, surname&populate[id_reservation]=%2A&populate[id_yacht][populate][id_attendance][populate][id_user_provision][populate][id_users_permissions_user][fields][0][1]=name, surname',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => ({
      meta: data?.meta,
      data: data?.data.map((item) => ({
        id: item?.id,
        attributes: {
          ...item?.attributes,
          date_out: `${item?.attributes?.requested_date
            ? dayjs(item?.attributes?.requested_date).format('DD-MM-YYYY')
            : '-'
            } / ${item?.attributes?.check_out_date ? dayjs(item?.attributes?.check_out_date).format('DD-MM-YYYY') : '-'}`,
          id: item?.id,
        },
      })),
    }),
  },
  departments: {
    path: '/departments?pagination[page]=1&pagination[pageSize]=1000&sort[name_department]=asc',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data.map((item) => ({
        name: item.attributes.name_department,
        id: item.id,
      })),
  },
  teams: {
    path: '/teams?pagination[page]=1&pagination[pageSize]=1000&sort[name]=asc',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data?.map((item) => ({
        name: item?.attributes?.name || '-',
        id: item?.id,
      })),
  },
  createTicket: {
    path: '/tickets',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          type: body?.type || null,
          id_yacht: body?.id_yacht ?? null,
          priority: body?.priority || 'MEDIUM',
          status: body?.status || 'OPEN',
          id_department: body?.id_department || null,
          id_team: body?.id_team || null,
          created_by_user_id: body?.created_by_user_id ?? null,
          assignee_user_id: body?.assignee_user_id ?? null,
          title: body?.ticket_title ?? body?.title ?? '',
          description: body?.ticket_description ?? body?.description ?? '',
          date: body?.date ?? null,
        },
      };
    },
  },
  tickets: {
    path: '/tickets?populate[id_yacht][fields][0]=yacht_name&populate[notes][populate][id_user][populate][id_users_permissions_user][fields][0]=name&populate[notes][populate][id_user][populate][id_users_permissions_user][fields][1]=surname&populate[id_department][fields][0]=name_department&populate[id_team]=*&populate[created_by_user_id][populate][id_users_permissions_user][fields][0]=name&populate[created_by_user_id][populate][id_users_permissions_user][fields][1]=surname&populate[assignee_user_id][populate][id_users_permissions_user][fields][0]=name&populate[assignee_user_id][populate][id_users_permissions_user][fields][1]=surname&populate[closed_by_user_id][populate][id_users_permissions_user][fields][0]=name&populate[closed_by_user_id][populate][id_users_permissions_user][fields][1]=surname',
    method: 'GET',
    get: null,
    auth: true,
    fallback: { data: [], meta: {} },
    transform: (data) => ({
      meta: data?.meta,
      data: (data?.data || []).map((item) => ({
        id: item.id,
        attributes: {
          type: {
            type: item.attributes.type,
            id: item.id,
            status: item.attributes.status || null,
          },
          yacht_name: item.attributes.id_yacht?.data?.attributes?.yacht_name || '-',
          assignee_user: `${item.attributes.assignee_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.name || ''} ${item.attributes.assignee_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.surname || ''}`.trim() || '-',
          assignee_user_id: item.attributes.assignee_user_id?.data?.id || null,
          priority: item.attributes.priority,
          status: {
            status: item.attributes.status,
            id: item.id,
          },
          handover: {
            title: item.attributes.title || '',
            description: item.attributes.description || '',
          },
          title: item.attributes.title || '',
          description: item.attributes.description || '',
          users_info: {
            createdAt: item.attributes.createdAt || null,
            created_by_user:
              `${item.attributes.created_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.name || ''} ${item.attributes.created_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.surname || ''}`.trim() || '-',
            closed_by_user:
              `${item.attributes.closed_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.name || ''} ${item.attributes.closed_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.surname || ''}`.trim() || '-',
            status: item.attributes.status || '',
          },
          notes:
            item.attributes.notes?.map((note) => {
              const user =
                note?.id_user?.data?.attributes?.id_users_permissions_user?.data?.attributes;

              return {
                comment: note.comment,
                created_at_note: note.created_at_note,
                id_user: note?.id_user?.data?.id || null,
                user_name: user ? `${user.name} ${user.surname}` : '-',
              };
            }) || [],
          department: item.attributes.id_department?.data?.attributes?.name_department || '-',
          team: item.attributes.id_team?.data?.attributes?.name || '-',
          closed_by_user: `${item.attributes.closed_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.name || ''} ${item.attributes.closed_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.surname || ''}`.trim() || '-',
          closed_by_user_id: item.attributes.closed_by_user_id?.data?.id || null,
          created_by_user: `${item.attributes.created_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.name || ''} ${item.attributes.created_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.surname || ''}`.trim() || '-',
          createdAt: item.attributes.createdAt,
          date: {
            date: item.attributes.date,
            id: item.id,
          },
        },
      })),
    }),
  },
  updateAll: {
    path: '/tickets/updateMany',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ids: body?.ids || [],
        ...(body?.status?.id ? { status: body.status.id } : {}),
        ...(body?.priority?.id ? { priority: body.priority.id } : {}),
      },
    }),
  },
  updateTicket: {
    path: '/tickets/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      const data = {
        ...(body?.type !== undefined ? { type: body?.type?.id || body?.type } : {}),
        ...(body?.priority !== undefined
          ? { priority: body?.priority?.id || body?.priority }
          : {}),
        ...(body?.status !== undefined
          ? { status: body?.status?.id || body?.status }
          : {}),
        ...(body?.assignee_user_id !== undefined
          ? { assignee_user_id: body.assignee_user_id }
          : {}),
        ...(body?.title !== undefined ? { title: body.title } : {}),
        ...(body?.description !== undefined
          ? { description: body.description }
          : {}),
        ...(body?.notes !== undefined ? { notes: body.notes } : {}),
        ...(body?.id_yacht !== undefined ? { id_yacht: body.id_yacht } : {}),
        ...(body?.id_department !== undefined
          ? { id_department: body.id_department }
          : {}),
        ...(body?.id_team !== undefined ? { id_team: body.id_team } : {}),
        ...(body?.created_by_user_id !== undefined
          ? { created_by_user_id: body.created_by_user_id }
          : {}),
        ...(body?.closed_by_user_id !== undefined
          ? { closed_by_user_id: body.closed_by_user_id }
          : {}),
        ...(body?.date !== undefined
          ? { date: body.date }
          : {}),
        ...(body?.title !== undefined
          ? { title: body.title }
          : {}),
        ...(body?.description !== undefined
          ? { description: body.description }
          : {}),
      };

      return { data };
    },
  },
  getTicket: {
    path: '/tickets/{{id}}?populate[id_yacht][fields][0]=yacht_name&populate[notes][populate][id_user][populate][id_users_permissions_user][fields][0]=name&populate[notes][populate][id_user][populate][id_users_permissions_user][fields][1]=surname&populate[id_department][fields][0]=name_department&populate[id_team]=*&populate[created_by_user_id][populate][id_users_permissions_user][fields][0]=name&populate[created_by_user_id][populate][id_users_permissions_user][fields][1]=surname&populate[assignee_user_id][populate][id_users_permissions_user][fields][0]=name&populate[assignee_user_id][populate][id_users_permissions_user][fields][1]=surname&populate[closed_by_user_id][populate][id_users_permissions_user][fields][0]=name&populate[closed_by_user_id][populate][id_users_permissions_user][fields][1]=surname',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => ({
      data: {
        type: data?.data?.attributes?.type || null,
        id: data?.data?.id,
        yacht_name: data?.data?.attributes?.id_yacht?.data?.attributes?.yacht_name || '-',
        department: data?.data?.attributes?.id_department?.data?.attributes?.name_department || '-',
        team: data?.data?.attributes?.id_team?.data?.attributes?.name || '-',
        created_by_user: `${data?.data?.attributes?.created_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.name || ''} ${data?.data?.attributes?.created_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.surname || ''}`.trim() || '-',
        assignee_user_id: {
          id: data?.data?.attributes?.assignee_user_id?.data?.id,
          name: `${data?.data?.attributes?.assignee_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.name || ''} ${data?.data?.attributes?.assignee_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.surname || ''}`.trim(),
        },
        assignee_user: `${data?.data?.attributes?.assignee_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.name || ''} ${data?.data?.attributes?.assignee_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.surname || ''} `.trim() || '-',
        closed_by_user_id: data?.data?.attributes?.closed_by_user_id?.data?.id || null,
        closed_by_user: `${data?.data?.attributes?.closed_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.name || ''} ${data?.data?.attributes?.closed_by_user_id?.data?.attributes?.id_users_permissions_user?.data?.attributes?.surname || ''} `.trim() || '-',
        priority: data?.data?.attributes?.priority,
        status: data?.data?.attributes?.status,
        title: data?.data?.attributes?.title || '',
        description: data?.data?.attributes?.description || '',
        notes: data?.data?.attributes?.notes?.map((note) => {
          const user = note?.id_user?.data?.attributes?.id_users_permissions_user?.data?.attributes;

          return {
            comment: note?.comment,
            created_at_note: note?.created_at_note,
            id_user: note.id_user?.data?.id,
            user_name: user ? `${user.name} ${user.surname} ` : '-',
          };
        }) || [],
        createdAt: data?.data?.attributes?.createdAt,
        updatedAt: data?.data?.attributes?.updatedAt,
        date: data?.data?.attributes?.date,
      },
    }),
  },
  deleteTicket: {
    path: '/tickets/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },
};
